<template>
    <div class="adblock-placeholder">
        <BlockHtml
            v-if="!isPlaceholderProvided"
            class="blocker-placeholder"
            :plain-text="blockHtml"
        />
        <BaseLink
            v-else
            :href="placeholderData.url"
        >
            <Component
                :is="componentDataByImageType.instance"
                :data="componentDataByImageType.data"
                class="adblock-placeholder__base-image"
            />
        </BaseLink>
    </div>
</template>

<script>
import getBlockHtmlById from '~/assets/services/staticBlocks/getBlockHtmlById';
import BaseImage from '~/components/common/Image/BaseImage';
import ProgressiveImage from '~/components/common/Image/ProgressiveImage';
import BaseLink from '~/components/common/Link/BaseLink';
import BlockHtml from '~/src/components/BlockHtml';

export default {
    name: 'AdBlockPlaceholder',
    components: {
        ProgressiveImage,
        BaseImage,
        BaseLink,
        BlockHtml,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        placeholderData: {
            type: Object,
            default: null,
        },
        progressiveImage: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            blockHtml: '',
        };
    },
    computed: {
        isPlaceholderProvided() {
            return !!this.placeholderData;
        },
        componentDataByImageType() {
            const { img: src } = this.placeholderData;
            let instance = BaseImage;
            if (this.progressiveImage) {
                instance = ProgressiveImage;
            }
            return { instance, data: { src } };
        },
    },
    async mounted() {
        if (!this.isPlaceholderProvided) {
            try {
                const { html } = await getBlockHtmlById({ id: this.id });
                if (!html) {
                    throw new Error('Empty block html');
                }
                this.blockHtml = html;
            } catch {
                this.$emit('error', { id: this.id });
            }
        }
    },
};
</script>

<style lang="scss">
    .adblock-placeholder {
        &__base-image {
            width: 100%;
        }
    }
</style>
